export default __webpack_public_path__ + "static/media/alertYellow.2c382970.svg";